<app-tooltip [dynamic]="true" [message]="getFormTitle()">
  <span class="alert-form-header-title" data-cy="alert-form-header-title">{{getFormTitle()}}</span>
</app-tooltip>

@if (isViewMode) {
  <div class="alert-form-header-close" (click)="closeForm.emit()">
    <app-tooltip [dynamic]="false" [message]="'Close Alert Message'">
      <span class="iwp-icon-gen_close_l" data-cy="alert-form-header-close"></span>
    </app-tooltip>
  </div>
}
